import React from 'react';
import Icon from '../../../components/AppIcon';

const CATEGORY_COLORS = {
  Safety: { bg: 'bg-red-50', text: 'text-red-700', border: 'border-red-200', dot: 'bg-red-500' },
  Quality: { bg: 'bg-blue-50', text: 'text-blue-700', border: 'border-blue-200', dot: 'bg-blue-500' },
  Operations: { bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200', dot: 'bg-amber-500' },
  Documentation: { bg: 'bg-purple-50', text: 'text-purple-700', border: 'border-purple-200', dot: 'bg-purple-500' },
};

const TaskContextBanner = ({ task }) => {
  const cat = CATEGORY_COLORS?.[task?.category] || CATEGORY_COLORS?.Operations;

  return (
    <div className="bg-card border border-border rounded-2xl p-4 shadow-elevation-1">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-accent/10 flex items-center justify-center flex-shrink-0">
          <Icon name="ClipboardCheck" size={20} className="text-accent" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">Task Completed</span>
            <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border ${cat?.bg} ${cat?.text} ${cat?.border}`}>
              <span className={`w-1.5 h-1.5 rounded-full ${cat?.dot}`} />
              {task?.category}
            </span>
          </div>
          <h3 className="text-base font-semibold text-foreground mt-0.5 leading-tight">{task?.title}</h3>
          {task?.site?.site_name && (
            <p className="text-xs text-muted-foreground mt-1 flex items-center gap-1">
              <Icon name="MapPin" size={11} />{task?.site?.site_name}
            </p>
          )}
        </div>
      </div>
      <div className="mt-3 pt-3 border-t border-border flex items-center gap-2">
        <div className="flex items-center gap-1.5 px-3 py-1.5 bg-amber-50 border border-amber-200 rounded-lg">
          <Icon name="Camera" size={13} className="text-amber-600" />
          <span className="text-xs font-semibold text-amber-700">Photo documentation required</span>
        </div>
        {task?.required && (
          <div className="flex items-center gap-1.5 px-3 py-1.5 bg-red-50 border border-red-200 rounded-lg">
            <Icon name="AlertCircle" size={13} className="text-red-600" />
            <span className="text-xs font-semibold text-red-700">Required task</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default TaskContextBanner;
